import { Controller } from "@hotwired/stimulus"

// FD-497: one shared favorite form for the whole sidebar (this controller sits on the
// <nav>). Each project row's star is a plain <button data-action="sidebar-favorites#toggle">
// carrying its URL/method/params — with ~90 projects, per-row button_to forms cost ~1.2KB
// + a CSRF token each. toggle points the shared form at the button's URL and submits it;
// Turbo handles the submit + redirect exactly like the per-row forms did.
//
// preventDefault cancels the enclosing <summary>'s default toggle (stopPropagation alone
// wouldn't — this mirrors the FD-413 favorite-toggle controller it replaces). Keyboard
// activation stays intact: Enter/Space on the focused button fire the same click event.
export default class extends Controller {
  static targets = ["form", "method", "id"]

  connect() {
    this.createUrl = this.formTarget.getAttribute("action")
  }

  // A button with data-favorite-url is an unfavorite (DELETE that favorite); without
  // it, toggle POSTs the form's default action (favorites#create) with the button's
  // data-favorite-id — so the ~90 favorite buttons don't each repeat the create URL.
  toggle(event) {
    event.preventDefault()
    event.stopPropagation()
    const { favoriteUrl, favoriteId } = event.currentTarget.dataset
    this.formTarget.action = favoriteUrl || this.createUrl
    this.methodTarget.disabled = !favoriteUrl
    this.idTarget.value = favoriteId || ""
    this.formTarget.requestSubmit()
  }
}
